<template>
  <Row>
    <Col :span="9">
      <CellGroup inset>
        <Field v-model="SearchQuery.likeQuery.order_number" center placeholder="订单编号" clearable="true"/>
      </CellGroup>
    </Col>
    <Col :span="9">
      <CellGroup inset>
        <Field v-model="SearchQuery.likeQuery.design_user_name" center placeholder="设计师"  clearable/>
      </CellGroup>
    </Col>
    <Col :span="6">
      <Button icon="search" color="var(--base-color)" @click="search" style="border-radius:5px">搜索</Button>
    </Col>
  </Row>
  <List
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      style="margin-top: 10px"
  >
    <CellGroup inset v-for="(item,index) in list" :key="item" style="margin-top: 10px">
      <Cell class="my-cell-title">
        <template #title>
          <span style="color:var(--base-color);">{{ index + 1 }}</span>
          订单编号：{{ item.orderNumber }}
        </template>
        <template #value>
          <Tag size="large" v-if="item.stateCode=='待支付定金'" color="#CCE8C0" text-color="#3D9C14" style="border:1px solid #3D9C14">待支付定金</Tag>
          <Tag size="large" v-else-if="item.stateCode=='待完成初稿'" color="#F4D1F7" text-color="#BB53DE" style="border:1px solid #BB53DE">待完成初稿</Tag>
          <Tag size="large" v-else-if="item.stateCode=='待完成定稿'" color="#FFB9CD" text-color="#F5396F" style="border:1px solid #F5396F">待完成定稿</Tag>
          <Tag size="large" v-else-if="item.stateCode=='待支付尾款'" color="#D4E4F9" text-color="#1B70E0" style="border:1px solid #1B70E0">待支付尾款</Tag>
          <Tag size="large" v-else-if="item.stateCode=='待上传定稿'" color="#F7E6D1" text-color="#FF5F08" style="border:1px solid #FF5F08">待上传定稿</Tag>
          <Tag size="large" v-else-if="item.stateCode=='待采购'" color="#F7D1D1" text-color="#E60012" style="border:1px solid #E60012">待采购</Tag>
          <Tag size="large" v-else-if="item.stateCode=='待发货'" color="#C7FCF8" text-color="#5FBBB3" style="border:1px solid #5FBBB3">待发货</Tag>
          <Tag size="large" v-else-if="item.stateCode=='已发货'" color="#F2FBAA" text-color="#545E00" style="border:1px solid #545E00">已发货</Tag>
          <Tag size="large" v-else-if="item.stateCode=='完成'" color="#FBE2A4" text-color="#AA7F19" style="border:1px solid #AA7F19">完成</Tag>
        </template>
      </Cell>
      <div>
        <Grid :column-num="2" :border="false">
          <GridItem class="show-data-gridItem" :text="`设计师:${item.designUserName?item.designUserName:''}`"/>
          <GridItem class="show-data-gridItem" :text="`设计开始时间:${item.designCreateTime?item.designCreateTime:''}`"/>
          <GridItem class="show-data-gridItem" :text="`定稿完成时间:${item.finalDraftTime?item.finalDraftTime:''}`"/>
          <GridItem class="show-data-gridItem" :text="`上传完成时间:${item.finalUploadTime?item.finalUploadTime:''}`"/>
        </Grid>
      </div>
    </CellGroup>
  </List>
</template>

<script setup>
import {
  Cell,
  CellGroup,
  Field,
  Button,
  Tag,
  Col,
  Row,
  Calendar,
  List,
  Grid, GridItem
} from 'vant';
import {onMounted, reactive, ref} from "vue";
import {getDesignPage} from "@/api/design";


//分页相关
let pageNum = ref(1)
let pageSize = ref(10)

let SearchQuery = reactive({
  likeQuery: {order_number: '',design_user_name:''},
})

const list = ref([]);
const loading = ref(false);
const finished = ref(false);

const onLoad = () => {
  getDesignPage(SearchQuery, pageNum.value, pageSize.value).then(res => {
    if (res.data.records.length > 0) {

      pageNum.value++;
      list.value.push(...res.data.records)
      // 加载状态结束
      loading.value = false;
    } else {
      finished.value = true;
    }
  })
}

const search = () => {
  pageNum.value=0
  list.value.splice(0, list.value.length)
  onLoad()
}


onMounted(() => {
  // load()
})
</script>

<style scoped>

</style>
